import { z } from 'zod';
import { ModuleConfigurationSchema } from './module-configuration';
export const ScheduleSchema = z.object({
    startTime: z.string().optional(),
    endTime: z.string().optional()
});
export const VariantCaseSchema = z.object({
    variant: z.union([z.string(), z.boolean()]),
    value: ModuleConfigurationSchema.optional()
});
export const EXPERIMENT_TYPE_VALUE = 'experiment';
export const ExperimentTypeSchema = z.literal(EXPERIMENT_TYPE_VALUE);
export const PERSONALIZATION_TYPE_VALUE = 'personalization';
export const PersonalizationTypeSchema = z.literal(PERSONALIZATION_TYPE_VALUE);
export const ExperimentTargetSchema = z.object({
    id: z.string(),
    type: z.union([z.literal('string'), z.literal('boolean')])
});
export const ExperimentSchema = z.object({
    type: ExperimentTypeSchema,
    target: ExperimentTargetSchema,
    label: z.string(),
    schedule: ScheduleSchema.optional(),
    cases: z.array(VariantCaseSchema)
});
export const PersonalizationTargetSchema = z.object({
    id: z.string(),
    entityType: z.union([
        z.literal('AJS_ANONYMOUS_USER'),
        z.literal('ATLASSIAN_ACCOUNT'),
        z.literal('EMAIL_UUID'),
        z.literal('ORG'),
        z.literal('SITE'),
        z.literal('SITE_USER'),
        z.literal('TRELLO_USER'),
        z.literal('CUSTOMER_DOMAIN')
    ]),
    type: z.union([z.literal('string'), z.literal('boolean')])
});
export const PersonalizationSchema = z.object({
    type: PersonalizationTypeSchema,
    target: PersonalizationTargetSchema,
    label: z.string(),
    schedule: ScheduleSchema.optional(),
    cases: z.array(VariantCaseSchema)
});
export const VariantSchema = z.union([
    ExperimentSchema,
    PersonalizationSchema
]);
//# sourceMappingURL=variant.js.map